import { DatabaseIcon } from './DatabaseIcon';

/**
 * author: Simran
 * id C8FC48A7-AE19-4BD8-B57E-14B76D93937B
 * name database
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/database.svg
 * tags
 * - Geographic Information System 
 * - Database 
 */
export const StorageIcon = DatabaseIcon;
export default StorageIcon